import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RiUserLine, RiLockPasswordLine } from "react-icons/ri";
import { useGlobalState } from "../Context/GlobalStateContext";
import { loginURL } from "../API/apiurls";
import { getLandingPath } from "../Utils/modulos";
import "../Styles/login.css";

export function Login() {
  const { userData, setUserData } = useGlobalState();
  const [usuario, setUsuario] = useState("");
  const [contrasena, setContrasena] = useState("");
  const [error, setError] = useState("");
  const navigation = useNavigate();
 
  useEffect(() => {
    const empresa = localStorage.getItem("empresaid");
    if (empresa) {
      navigation(getLandingPath(userData), { replace: true });
    }
  }, [navigation, userData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!usuario || !contrasena) {
      setError("Por favor, complete todos los campos.");
      return;
    }
    try {
      const dataInicio = { usuario, password: contrasena };
      const response = await axios.post(loginURL, dataInicio);
      const empresa = response.data;

      const nextUserData = {
        empresaId: empresa.id,
        empresaNombre: empresa.nombre,
        empresaUsuario: empresa.usuario,
        moduloGeocercas: empresa.moduloGeocercas !== false,
        moduloPausas: empresa.moduloPausas === true,
        moduloCinturones: empresa.moduloCinturones === true,
      };

      localStorage.setItem("empresaid", empresa.id);
      localStorage.setItem("empresaNombre", empresa.nombre);
      localStorage.setItem("userData", JSON.stringify(nextUserData));

      setUserData(nextUserData);
      navigation(getLandingPath(nextUserData), { replace: true });
    } catch (error) {
      console.error("Error:", error);
      setError("Error en inicio de sesión");
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        <div className="login-brand">
          <h1 className="login-title">Ruta Segura</h1>
          <p className="login-subtitle">Acceso al sistema</p>
        </div>
        <div className="input-group">
          <label htmlFor="usuario">
            <RiUserLine /> Usuario:
          </label>
          <input type="text" id="usuario" value={usuario} onChange={(e) => setUsuario(e.target.value)} required placeholder="Usuario" />
        </div>
        <div className="input-group">
          <label htmlFor="contrasena">
            <RiLockPasswordLine /> Contraseña:
          </label>
          <input type="password" id="contrasena" value={contrasena} onChange={(e) => setContrasena(e.target.value)} required placeholder="Password" />
        </div>
        {error && <div className="error-message">{error}</div>}
        <button type="submit" className="login-submit">
          Login
        </button>
      </form>
    </div>
  );
}
